<script lang="ts">
	import { slide } from 'svelte/transition';
	import Button from '#lib/components/ui/Button.svelte';
	import { strings } from '#lib/ui/strings.ts';

	type Props = {
		groupName: string;
		id?: string;
		totalCards?: number;
		totalAllowedCards?: number;
		onDrawCard?: () => void;
		onClearAll?: () => void;
	};

	let { groupName, id, totalCards, totalAllowedCards, onDrawCard, onClearAll }: Props = $props();
</script>

<div class="section-header">
	<h2 {id} tabindex="-1" class="text-2xl mb-4">
		{groupName}{totalCards === undefined
			? ''
			: ' (' + totalCards + (!totalAllowedCards ? ')' : ` / ${totalAllowedCards})`)}
	</h2>
	{#if onDrawCard}
		<div transition:slide>
			<Button onclick={onDrawCard}>{strings.drawButton}</Button>
		</div>
	{/if}
	{#if onClearAll}
		<div transition:slide>
			<Button onclick={onClearAll}>{strings.clearAllButton}</Button>
		</div>
	{/if}
</div>

<style>
	.section-header {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: var(--space-4);
		user-select: none;
	}

	@media (max-height: 500px) and (orientation: landscape) {
		.section-header {
			flex-direction: row;
			flex-wrap: wrap;
			justify-content: center;
			gap: var(--space-3);
		}

		h2 {
			margin-bottom: 0;
		}
	}
</style>
